import React from 'react';

const EmDash = () => {
  return <span>&mdash;</span>;
};

export default EmDash;
